<script lang="ts">
    import { trans } from '$assets/shop-translator.js';
    import PriceAside from '$saga/views/Tour/Aside/PriceAside.svelte';

    export let allTourUrl: string,
        originalPrice: number | null,
        rebateAmount: number | null,
        minPrice: number | null;
</script>

<div
    class="fixed bottom-0 left-0 flex w-full items-center justify-between border-t border-solid border-border-quiet
    bg-container-commercial-neutral px-m py-xs text-content-neutral
    desktop:sticky desktop:right-0 desktop:top-[100px] desktop:block desktop:w-[300px] desktop:min-w-[300px] desktop:flex-col desktop:border-none desktop:p-m"
>
    <div class="mb-m hidden desktop:block">
        <PriceAside {originalPrice} {rebateAmount} {minPrice} />
    </div>
    <div
        class="border border-solid border-border-brand p-xs text-sm text-content-brand desktop:flex desktop:flex-col"
    >
        <span>{trans('tour.aside_panel.sale.closed')}</span>
        <a class="underline hover:no-underline" href={allTourUrl}>
            {trans('tour.aside_panel.sale.see_travels')}
        </a>
    </div>
</div>
